import * as D from '../../data';
import type { LayerConfig, PixelType } from '../../type';

export const getLayerOffset = (
  layerConfig: LayerConfig,
  _pixels: PixelType[][],
  layerIndex: number,
) => {
  if (layerConfig.id === 'background') {
    return 0;
  }

  const treeIndex = Math.floor(layerIndex / 2);

  return treeIndex * D.TOTAL_PIXELS;
};

export const getPixelNumber = (
  rowIndex: number,
  colIndex: number,
  pixels: PixelType[][],
  layerConfig: LayerConfig,
  layerIndex: number,
) => {
  const layerOffset = getLayerOffset(layerConfig, pixels, layerIndex);
  const pixelInCurrentLayer =
    (pixels.length - 1 - rowIndex) * pixels[0].length + colIndex;
  return layerOffset + pixelInCurrentLayer;
};

export const isPixelVisible = (
  rowIndex: number,
  colIndex: number,
  pixels: PixelType[][],
  fillCount: number,
) => {
  const pixelNumber =
    (pixels.length - 1 - rowIndex) * pixels[0].length + colIndex;
  return pixelNumber < fillCount;
};

export const isUserContribution = (
  rowIndex: number,
  colIndex: number,
  pixels: PixelType[][],
  userContribution?: {
    startPixel: number;
    pixelCount: number;
  } | null,
) => {
  if (!userContribution) {
    return false;
  }

  const pixelNumber =
    (pixels.length - 1 - rowIndex) * pixels[0].length + colIndex;

  return (
    pixelNumber >= userContribution.startPixel &&
    pixelNumber < userContribution.startPixel + userContribution.pixelCount
  );
};
